import React from 'react';
import ReactDOM from 'react-dom';
import ApartmentLike from "../elements/components/ApartmentLike";
import BookingCalendar from '../booking_engine/components/BookingCalendar';
import booking_engine_analytics from '../booking_engine_analytics'
import * as Sentry from "@sentry/react";
const MIX_SENTRY_LARAVEL_DSN = process.env.MIX_SENTRY_LARAVEL_DSN;
Sentry.init({
  dsn: MIX_SENTRY_LARAVEL_DSN
});

const root = document.getElementById('root');
const guestsLimit = parseInt(root.dataset['guests_limit'], 10)
const adultsLimit = parseInt(root.dataset['adults_limit']);
const kidsLimit = parseInt(root.dataset['kids_limit']);
const babiesLimit = parseInt(root.dataset['babies_limit']);
const currentApartmentId = root.dataset.currentApartmentId;
const sessionApartmentId = root.dataset.sessionApartmentId;
const lite = root.dataset.lite;
const locale = root.dataset.locale;

const descContainer = document.getElementById("opis");
const descHTML = descContainer.innerHTML;
const regex = /(★)+/g;

const rootElement = document.getElementById("apartment-like");
const active = rootElement.getAttribute('data-active');

descContainer.innerHTML = descHTML.replace(regex, function (stars) {
    return `<span class="star star-p">${stars}</span>`;
});

fbq('track', 'ViewContent', {content_type: 'product', content_ids: [currentApartmentId]})

ReactDOM.render(<ApartmentLike apartmentId={currentApartmentId} active={active}/>, rootElement);

ReactDOM.render(
    <BookingCalendar
        initData={{
            guestsLimit,
            adultsLimit,
            kidsLimit,
            babiesLimit,
            currentApartmentId,
            sessionApartmentId,
            locale,
            lite
        }}
    />
    , root
);
